import { render } from "./V404View.vue?vue&type=template&id=2f745f0b&ts=true"
import script from "./V404View.vue?vue&type=script&lang=ts"
export * from "./V404View.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__